import { SaleOrderMergeData } from '../../data';
import { DateTime } from 'luxon';
import { CurrencyFormatter } from '../../../../../utilities';
import { SaleOrderStatus } from '../../../../../entities';

export class FakeSaleOrderMergeData extends SaleOrderMergeData {
    constructor() {
        super();

        this._id = '0c573a9a-a442-4d40-865b-b2225e13b41d';
        this.saleOrderNumber = 'SO1000';
        this.status = SaleOrderStatus.Invoiced;
        this.date = DateTime.local().toFormat('dd/MM/yyyy');
        this.expiryDate = DateTime.local().plus({ days: 30 }).toFormat('dd/MM/yyyy');
        this.createdBy = 'Sales User';
        this.createdDate = this.date;
        this.name = 'Customer Sale Order';
        this.customerRef = 'Customer Reference';
        this.jobNumber = 'J1000';
        this.workOrderNumber = 'J1000-10431';

        this.totalEx = CurrencyFormatter.formatCurrency(200, 2);
        this.totalInc = CurrencyFormatter.formatCurrency(500, 2);
        this.totalTax = CurrencyFormatter.formatCurrency(100, 2);
    }
}